var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.469 175.249L107.83 111.159C107.516 110.341 108.33 109.543 109.141 109.874L175.65 137.032C176.589 137.416 176.426 138.793 175.422 138.946L144.26 143.704C143.876 143.763 143.561 144.037 143.452 144.409L134.361 175.174C134.091 176.09 132.812 176.141 132.469 175.249Z",
    stroke: "#59BD39",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 162H46M162 100V45.5M46 38H154.5M38 45.5V100V154",
    stroke: "#1B1B1B",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 12,
    height: 12,
    stroke: "#1B1B1B",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 32,
    width: 12,
    height: 12,
    stroke: "#1B1B1B",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 156,
    width: 12,
    height: 12,
    stroke: "#1B1B1B",
    strokeWidth: 4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export default ForwardRef;